

import { Site } from "./types";

// Hardcoded site data for specific sites
export const getBelleRecyclageSite = (): Site => {
  return {
    id: "ab3cc5c8-aab4-4284-a282-37384f3c6e45",
    name: "Centre de Bellé recyclage",
    address: "Camp Franc",
    city: "Sainte-Radegonde",
    postalCode: "12850",
    phone: "05 65 78 01 25",
    email: "contactgfe@groupefabre.com",
    coordinates: {
      lat: 44.3637,
      lng: 2.6367
    },
    services: ["Achat de métaux", "Recyclage", "Collecte", "Valorisation", "Location de benne"],
    description: "Centre de traitement et de valorisation des déchets à Sainte-Radegonde.",
    opening_hours: {
      lundi: { matin: "8h30-12h00", apres_midi: "14h00-17h30" },
      mardi: { matin: "8h30-12h00", apres_midi: "14h00-17h30" },
      mercredi: { matin: "8h30-12h00", apres_midi: "14h00-17h30" },
      jeudi: { matin: "8h30-12h00", apres_midi: "14h00-17h30" },
      vendredi: { matin: "8h30-12h00", apres_midi: "14h00-17h30" },
      samedi: { matin: "8h30-12h00", apres_midi: "Fermé" },
      dimanche: { matin: "Fermé", apres_midi: "Fermé" }
    },
    reviewUrl: "https://www.google.com/search?sca_esv=768393473445289f&rlz=1C1LZQR_frFR1084FR1085&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-Ex8LmkJi3xES5TzpXdFazmabZJari4OGRkvmKIwxOwdaIZWGjGQdqLQK2cm8I_pPC08WNBFnD5iGAQRZGs6kWfvm9GKFqZfSR6Jw4yEWH0k4-opdGw%3D%3D&q=SAS+Bell%C3%A9+-+Fer+et+M%C3%A9taux+Avis&sa=X&ved=2ahUKEwiwhLql-8ONAxUkBfsDHR9ECvgQ0bkNegQITRAE&biw=2560&bih=1271&dpr=1.5",
    websiteUrl: "https://www.bellerecyclage.fr/"
  };
};

export const getBrianeJeanSite = (): Site => {
  return {
    id: "bf775ebc-24ce-45b2-ac61-953a6f34652e",
    name: "Centre de Briane Jean Récupération",
    address: "Le Pré de Bouques",
    city: "Lédergues",
    postalCode: "12170",
    phone: "05 65 46 28 95",
    email: "contactgfe@groupefabre.com",
    coordinates: {
      lat: 44.060628,
      lng: 2.446451
    },
    services: ["Achat de métaux", "Collecte de ferraille", "Recyclage", "Récupération de déchets", "Dépollution VHU", "Location de benne"],
    description: "Spécialiste de la récupération et du recyclage des métaux à Lédergues.",
    opening_hours: {
      lundi: { matin: "8h00-12h00", apres_midi: "14h00-18h00" },
      mardi: { matin: "8h00-12h00", apres_midi: "14h00-18h00" },
      mercredi: { matin: "8h00-12h00", apres_midi: "14h00-18h00" },
      jeudi: { matin: "8h00-12h00", apres_midi: "14h00-18h00" },
      vendredi: { matin: "8h00-12h00", apres_midi: "14h00-18h00" },
      samedi: { matin: "8h00-12h00", apres_midi: "Fermé" },
      dimanche: { matin: "Fermé", apres_midi: "Fermé" }
    },
    reviewUrl: "https://g.co/kgs/BxyGhHY",
    websiteUrl: "https://www.briane-jean.fr/"
  };
};
